import axiosInstance from "../../common/axiosInstance";
import { premisesApiResponse } from "../../types/api";

export const getPremises = () => {
  return axiosInstance.get("/api/premises");
};

export interface PremisesListParams {
  page: number;
  pageSize: number;
  search?: string;
  regionId?: string;
  premiseId?: string;
}

interface PremisesPageResponse {
  success: boolean;
  data: premisesApiResponse[];
  meta?: {
    pagination?: {
      page: number;
      pageSize: number;
      total: number;
      totalPages: number;
    };
  };
  error?: unknown;
  requestId?: string;
}

export const getPremisesPage = (params: PremisesListParams) => {
  return axiosInstance.get<PremisesPageResponse>("/api/v2/premises/list", { params });
};

export interface PremiseOption {
  id: string;
  premisesName: string;
  region: string | null;
  regionName: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  meta?: unknown;
  error?: unknown;
  requestId?: string;
}

export const getPremiseOptions = async (): Promise<PremiseOption[]> => {
  const response = await axiosInstance.get<ApiResponse<PremiseOption[]>>(
    "/api/v2/premises/options"
  );

  const options = response.data?.data;

  if (!Array.isArray(options)) {
    throw new Error("Invalid premise options response: expected an array");
  }

  return options;
};

export const getAllPremises = () => {
  return axiosInstance.get("/api/premises/all");
};

export const getPremiseById = (id: string) => {
  return axiosInstance.get(`/api/premises/${id}`);
};

export const createPremises = (data: any) => {
  return axiosInstance.post("/api/premises", data);
};

export const updatePremises = (id: string, data: any) => {
  return axiosInstance.put(`/api/premises/${id}`, data);
};

export const deletePremises = (id: string) => {
  return axiosInstance.delete(`/api/premises/${id}`);
};

export const togglePremiseStatus = (id: string) => {
  return axiosInstance.put(`/api/premises/toggle-status/${id}`);
};

export const filterPremisesByRegion = (regionId: string) => {
  return axiosInstance.get(`/api/premises/filter/region/${regionId}`);
};

export const searchPremises = (keyword: string) => {
  return axiosInstance.get(`/api/premises/search/${keyword}`);
};

// Regions API
export const getRegions = () => {
  return axiosInstance.get("/api/regions");
};

export const createRegion = (data: any) => {
  return axiosInstance.post("/api/regions", data);
};

export const updateRegion = (id: string, data: any) => {
  return axiosInstance.put(`/api/regions/${id}`, data);
};

export const deleteRegion = (id: string) => {
  return axiosInstance.delete(`/api/regions/${id}`);
};

// Departments API
export const getDepartments = () => {
  return axiosInstance.get("/api/departments");
};

export const createDepartment = (data: any) => {
  return axiosInstance.post("/api/departments", data);
};

export const updateDepartment = (id: string, data: any) => {
  return axiosInstance.put(`/api/departments/${id}`, data);
};

export const deleteDepartment = (id: string) => {
  return axiosInstance.delete(`/api/departments/${id}`);
};
